import { Action } from './base'
import API from 'app/services/company/companyApi'
import { CompanyDetailsModel } from 'app/models/companyDetailsModel'
import { CompanyType } from 'app/constants/companyType'

export enum ActionTypeKeys {
  CHOOSE_COMPANY = 'CHOOSE_COMPANY',
  ENTER_COMPANY = 'ENTER_COMPANY',
  GET_COMPANIES = 'GET_COMPANIES',
}

export type CompanySelectionAction = Action<
  typeof ActionTypeKeys.CHOOSE_COMPANY,
  CompanyDetailsModel
>

export type EnterCompanyAction = Action<
  typeof ActionTypeKeys.ENTER_COMPANY,
  CompanyDetailsModel
>

export type GetCompaniesAction = Action<
  typeof ActionTypeKeys.GET_COMPANIES,
  CompanyDetailsModel[]
>

export function chooseCompany(
  company: CompanyDetailsModel,
): CompanySelectionAction {
  return {
    type: ActionTypeKeys.CHOOSE_COMPANY,
    payload: {
      ...company,
    },
  }
}

export const enterCompany = async (
  company: CompanyDetailsModel,
): Promise<any> => {
  const api = API.create()

  try {
    await api.changeCompany(company.id)

    return {
      type: ActionTypeKeys.ENTER_COMPANY,
      payload: {
        ...company,
      },
    }
  } catch (error) {
    return null
  }
}

export const getCompanies = async (): Promise<any> => {
  const api = API.create()

  try {
    const response = await api.getCompanies()
    const data = response.content.data
    const companies: Array<CompanyDetailsModel> = new Array<CompanyDetailsModel>()

    for (const company of data) {
      companies.push(mapCompanyFields(company))

      if (company.childCompanies != null) {
        for (const childCompany of company.childCompanies) {
          const current: CompanyDetailsModel = {
            ...mapCompanyFields(childCompany),
          }
          companies.push(current)
        }
      }
    }

    return companies
  } catch (error) {
    return []
  }
}

const mapCompanyFields = (company: any): CompanyDetailsModel => {
  return {
    id: company.id,
    companyName: company.companyName,
    type: company.type ? CompanyType.SERVICE : CompanyType.NORMAL,
    uniqueIdentifier: company.uniqueIdentifier,
    isValid: company.isValid,
    hasDatabase: company.hasDatabase,
    tenant: company.tenant,
    accountingOnly: company.accountingOnly,
    groups: company.groups || [],
  }
}

export type CompanySelectionActions =
  | CompanySelectionAction
  | GetCompaniesAction
  | EnterCompanyAction
